<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Race</router-link> |
      <router-link to="/result">Result</router-link> |
    </div> -->
    <HeaderComponent/>
    <transition name="fade" mode="out-in" appear>
      <router-view/>
    </transition>
    <FooterComponent/>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from '@/components/Header.vue'
import FooterComponent from '@/components/Footer.vue'

export default {
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
  text-align: center;
  height: 100%;
}
#nav {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  a {
    font-size: vw(20);
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
